/**
 * Long-poller that refreshes match data on a fixed interval and invokes
 * a callback with each new payload. Used by the root layout to keep
 * `appState.optaData` fresh while the user is on the page.
 */

import { POLL_INTERVAL } from './constants';
import { getData } from './endpoints';

const LOG_TAG = '[Poller]';

export class Poller {
  /** @param {(data: object) => void} callback Invoked with every fresh payload. */
  constructor(callback) {
    this.callback = callback;
    this.destroyed = false;
    this.tick = 0;
    this.timeout = null;
    // console.log(`${LOG_TAG} started (interval=${POLL_INTERVAL}ms)`);
    // Wait one interval before the first fetch — `+layout.ts`'s load
    // already supplied fresh data, so polling immediately would just
    // re-emit the same payload.
    this.setTimeout();
  }

  async longPoll() {
    if (this.destroyed) return;

    const tickId = ++this.tick;
    const started = performance.now();

    try {
      const newData = await getData({ fetch });
      const elapsed = Math.round(performance.now() - started);
      const matches = newData?.matches?.matches?.match?.length ?? 0;
      // console.log(
      //   `${LOG_TAG} tick #${tickId} ← ${elapsed}ms (matches=${matches})`
      // );
      this.callback(newData);
    } catch (err) {
      console.error(`${LOG_TAG} tick #${tickId} failed`, err);
    }

    this.setTimeout();
  }

  setTimeout() {
    if (this.destroyed) return;
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.longPoll(), POLL_INTERVAL);
  }

  destroy() {
    if (this.timeout != null) {
      clearTimeout(this.timeout);
      this.destroyed = true;
      // console.log(`${LOG_TAG} destroyed after ${this.tick} tick(s)`);
    }
  }
}
